import { IDataProviderFilter, IFilter } from 'core-components/types'

export const isIFilter = (value: IDataProviderFilter | IFilter): value is IFilter => {
  return (value as IFilter).value !== undefined
}
